// extracted by mini-css-extract-plugin
export default {"signedMessage":"SignedMessage_signedMessage__5wzb7","certifies":"SignedMessage_certifies__g74ie","bullet":"SignedMessage_bullet__xRsQ8"};